import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

interface PublicRouteProps {
  redirectPath?: string;
}

// This component prevents authenticated users from accessing public routes like login, register, etc.
const PublicRoute = ({
  redirectPath = "/",
}: PublicRouteProps) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  // If user is authenticated, redirect to the specified path
  if (isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  // Otherwise, render the public route
  return <Outlet />;
};

export default PublicRoute; 